
import { Job } from '../../domain/models/job';
import { Position } from '../../domain/models/position';
import { PositionType } from '../../domain/enums/positionType';
import { Coords } from '../../domain/models/coords';
import { Schedule } from '../../domain/models/schedule';
import { JobType } from '../../domain/enums/jobType';

import * as _ from 'lodash';

export class RouteDetailViewModel {
    public id: string;
    public name: string;
    public startDate: Date;
    public endDate: Date;
    public startTime: any;
    public endTime: any;
    public startAddress: string;
    public endAddress: string;
    public daysCalculated: number;
    public totalDays: number;
    public days: number[];
    public interval: number;
    public sectionLength: number;
    public finishedAt: Date;
    public jobType: JobType;
    public usesTomTomData: boolean;

    public startCoords: Coords;
    public endCoords: Coords;
    public wayPoints: Coords[];

    public wayPointsString: string[];
    public routeLength: number;
    public routePolyline: string;
    public cost: number;


    constructor();
    constructor(job: Job);
    constructor(id: string, name: string, jobType: JobType, startDate: Date, endDate: Date, routeLength: number, routePolyline: string,
        startAddress: string, endAddress: string, daysCalculated: number, totalDays: number);
    constructor(jobOrId?: any, name?: string, jobType?: JobType, startDate?: Date, endDate?: Date, routeLength?: number, routePolyline?: string,
        startAddress?: string, endAddress?: string, daysCalculated?: number, totalDays?: number) {
        if (jobOrId) {
            if (name) {
                this.id = jobOrId;
                this.name = name;
                this.jobType = jobType;
                this.startAddress = startAddress;
                this.endAddress = endAddress;
                this.routeLength = routeLength;
                this.routePolyline = routePolyline;
                this.endDate = endDate;
                this.daysCalculated = daysCalculated;
                this.totalDays = totalDays;
            } else {
                this.id = jobOrId.id;
                this.name = jobOrId.name;
                this.jobType = jobOrId.jobType;
                this.startAddress = jobOrId.startAddress;
                this.endAddress = jobOrId.endAddress;
                this.startDate = new Date(jobOrId.start);
                this.endDate = new Date(jobOrId.end);
                this.routeLength = jobOrId.routeLength;
                this.routePolyline = jobOrId.routePolyline;
                this.wayPoints = [];
                this.parseLocations(jobOrId.locations);
                this.totalDays = 0;
                this.daysCalculated = 0;
                this.days = jobOrId.schedule.days;
                this.startTime = jobOrId.schedule.startTime;
                this.endTime = jobOrId.schedule.endTime;
                this.finishedAt = jobOrId.finishedAt;
                this.usesTomTomData = jobOrId.usesTomTomData;

                this.interval = jobOrId.schedule.intervalMinutes;
                this.sectionLength = jobOrId.minimumSectionLength;
                this.cost = jobOrId.cost;

                this.calulateTotalDays(jobOrId.schedule, this.startDate, this.endDate, this.finishedAt);
            }
        }
    }

    private parseLocations(positions: Position[]): void {
        this.startCoords = new Coords(positions[0].y, positions[0].x);
        this.endCoords = new Coords(positions[positions.length - 1].y, positions[positions.length - 1].x);
        for (let i = 1; i < positions.length - 1; i++) {
            if (positions[i].type === PositionType.Waypoint) {
                this.wayPoints.push(new Coords(positions[i].y, positions[i].x));
            }
        }
    }

    private calulateTotalDays(schedule: Schedule, startDate: Date, endDate: Date, finishedAt: Date): void {
        let stop = new Date(endDate);
        stop.setHours(0, 0, 0, 0);
        let today = new Date();
        if (finishedAt) {
            today = new Date(finishedAt);
            today.setDate(today.getDate() + 1);
        }
        today.setHours(0, 0, 0, 0);

        let start = new Date(startDate);
        start.setHours(0, 0, 0, 0);

        for (let i = new Date(start); i <= stop; i.setDate(i.getDate() + 1)) {
            if (_.includes(schedule.days, i.getDay())) {
                this.totalDays++;
                if (i < today) {
                    this.daysCalculated++;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/viewModels/route-detail-viewmodel.ts